import React, { PureComponent } from 'react'
import { withRouter, Route, Switch } from 'react-router-dom'
import { TransitionGroup, CSSTransition } from 'react-transition-group'
import { PageContainer } from 'router'

import CalendarPage from 'pages/calendar'
import FocusViewPage from 'pages/focusview'
import TodoPage from './todoPage'
import ArchivePage from './archivePage'
import NotFound from 'pages/notFound'

import Header from 'features/todolist/components/header'

class TodoLayout extends PureComponent {
  render() {
    return (
      <div className="todo-layout">
        <Header />
        <TransitionGroup>
          <CSSTransition
            key={this.props.location.pathname}
            timeout={{ enter: 400, exit: 400 }}
            appear={true}
            mountOnEnter={true}
            unmountOnExit={true}
            classNames={'page-transition'}>
            <PageContainer>
              <Switch location={this.props.location}>
                <Route exact path="/" component={TodoPage} />
                <Route exact path="/index.html" component={TodoPage} />
                <Route exact path="/archive" component={ArchivePage} />
                <Route exact path="/calendar" component={CalendarPage} />
                <Route exact path="/calendar/:view" component={CalendarPage} />
                <Route exact path="/focusview" component={FocusViewPage} />
                <Route component={NotFound} />
              </Switch>
            </PageContainer>
          </CSSTransition>
        </TransitionGroup>
      </div>
    )
  }
}

export default withRouter(TodoLayout)



// WEBPACK FOOTER //
// ./src/pages/todolist/index.js